var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _vm._l(_vm.righeDistintaValide, function (row, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c(
            "v-row",
            {
              key: "r_" + i,
              staticStyle: { "background-color": "#f2f2f2" },
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "col-indice",
                  attrs: { "align-self": "center" },
                },
                [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(" " + _vm._s(row.innerRigaDistinta.posizRiga) + " "),
                  ]),
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "col-dati",
                  class: {
                    "col-dati-new": row.richiestaDiInserimento,
                    "deleted-from-as400": row.eliminataDaAs400,
                  },
                },
                [
                  !row.richiestaDiInserimento
                    ? _c("div", [
                        row.eliminataDaAs400
                          ? _c("em", [
                              _vm._v(" ELIMINATA DA AS 400 "),
                              _c("br"),
                            ])
                          : _vm._e(),
                        _vm._v(" Componente: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(row.innerRigaDistinta.componente) +
                              " (" +
                              _vm._s(row.innerRigaDistinta.idComponenteBga) +
                              ")"
                          ),
                        ]),
                        _vm._v(" - " + _vm._s(row.innerRigaDistinta.descri)),
                        _c("br"),
                        _vm._v(" Colore: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(row.innerRigaDistinta.coloreComponente) +
                              " (" +
                              _vm._s(
                                row.innerRigaDistinta.idColoreComponenteBgf
                              ) +
                              ")"
                          ),
                        ]),
                        _vm._v(", Unità di misura: "),
                        _c("strong", [
                          _vm._v(_vm._s(row.innerRigaDistinta.unMisuraDiBa)),
                        ]),
                        _vm._v(", id: "),
                        _c("em", [
                          _vm._v(_vm._s(row.innerRigaDistinta.idBgj) + ", "),
                        ]),
                        _vm._v(" Utilizzo: "),
                        _c("strong", [
                          _vm._v(_vm._s(row.innerRigaDistinta.utilizzo)),
                        ]),
                      ])
                    : _c("div", [
                        _c("strong", [
                          _vm._v("Riga inserita in attesa di validazione"),
                        ]),
                        _c("br"),
                        _vm._v(" Componente: "),
                        _c("strong", [
                          _vm._v(_vm._s(row.innerRigaDistinta.idComponenteBga)),
                        ]),
                        _vm._v(" - Colore: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(row.innerRigaDistinta.idColoreComponenteBgf)
                          ),
                        ]),
                        _vm._v(", Unità di misura: "),
                        _c("strong", [
                          _vm._v(_vm._s(row.innerRigaDistinta.unMisuraDiBa)),
                        ]),
                      ]),
                  _c(
                    "ul",
                    _vm._l(row.quantitaPerTaglia, function (qta, index) {
                      return _c("li", { key: "li_" + index }, [
                        _c("div", { staticClass: "gray" }, [
                          _vm._v(_vm._s(qta.desc)),
                        ]),
                        _vm._v(_vm._s(_vm._f("formatNumber")(qta.qta)) + " "),
                      ])
                    }),
                    0
                  ),
                  !row.richiestaDiInserimento &&
                  row.variazioniComunicate &&
                  row.variazioniComunicate.length > 0
                    ? _c("RigaDistintaListaVariazioni", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: { "riga-distinta": row },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }